export const blockIconsAudioandvideoSpeedNew = (
	<span className='material-symbols-outlined'>speed</span>
);
